module.exports = __webpack_public_path__ + "static/media/bouncing-ball.c1b68442.jpg";